import { EventBus, Events } from "jiffy-store";
import { deleteCookie } from "common/utils/cookie";
import { isPDP } from "common/utils/pages";
import { isCustomizableMadePage } from "components/jiffy/product-details/customizable-made-page-utils";

/**
 * Dispatches the zipcode updated event and clears PDP date cookie
 * @param {string} zipcode - The zipcode to dispatch
 */
export const dispatchZipcodeUpdatedEvent = zipcode => {
  deleteCookie("__JIFFY_PDP_DATE__");
  EventBus.publish(Events.ZIPCODE_UPDATED, null, zipcode);
};

/**
 * Handles PDP-specific address update flow
 * Consolidates common pattern: dispatch zipcode, cleanup, publish event
 *
 * @param {Object} address - Address data to update
 * @param {Function} cleanupCallback - Optional async callback for component-specific cleanup
 * @returns {boolean} Returns true if PDP flow was executed, false otherwise
 */
export const handlePDPAddressUpdate = async (address, cleanupCallback = null) => {
  if (!isPDP() && !isCustomizableMadePage()) {
    return false;
  }

  dispatchZipcodeUpdatedEvent(address.zipcode);

  if (cleanupCallback) {
    await cleanupCallback();
  }

  EventBus.publish(Events.LOCAL_DELIVERY_ADDRESS_UPDATED, address);

  return true;
};
